import {UserInfoModel} from "@/model/user-info/user-info.model";

export class ReservationModel {
    reservationId: string;
    reservationKey: string;
    userInfo: UserInfoModel;
}
